export const PRIVACY_POLICY_LINK = 'https://www.cian.ru/legal-documents/politika_konfidencialnosti_0/';
export const PERSONAL_DATA_AGREEMENT_LINK =
  'https://static.cdn-cian.ru/frontend/collections-assets/newbuilding/personal-data-agreement-about-kpn.pdf';
export const PERSONAL_DATA_CONSULTANT_CALLBACK_CONFIG_KEY =
  'newbuilding-consultants-frontend.personalDataConsultantCallback';
export const MARKETING_AGREEMENT_LINK = 'https://www.cian.ru/legal-documents/politika_konfidencialnosti_0/';
export const MARKETING_CONFIG_KEY = 'newbuilding-consultants-frontend.marketing';
